import React, { useEffect, useRef } from "react"
import Select from 'react-select';
import { useState } from "react";
import TextTruncate from "../utilsComponent/textTruncate";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT, REACT_APP_VAM_ENDPOINT } from "../urls";
import LoadingPage from "../reusableComponents/loader/loadingPage.jsx";
import NoDataFound from "../utilsComponent/noDataFound.jsx";
import { editModeOn, encryptValue, saveInLocalStorage } from "../utilFunctions.js";
import ListsPagination from "../utilsComponent/ListsPagination.jsx";
import { axiosRequest } from "../service.js";
import { functionalities } from "../consts.js";

const UserManagment = (props) => {
  const {roleDataCookie} = props
  const location = useLocation();
  const [usersList, setUsersList] = useState([])
  const [rolesList, setRolesList] = useState([])
  const [currentItems, setCurrentItems] = useState(null);
  const [userData, setUserData] = useState({});
  const [sortedRole, setSortedRole] = useState(false)
  const [sortedADStatus, setSortedADStatus] = useState(false)
  const [sortedCMSStatus, setSortedCMSStatus] = useState(false)
  const [sortedEmail, setSortedEmail] = useState(false)
  const [sortedJob, setSortedJob] = useState(false)
  const [sortedDepartment, setSortedDepartment] = useState(false);
  const [sortedMobile, setSortedMobile] = useState(false);
  const [loading, setLoading]=useState(false)
    
  const defaultSearch = {
    employeeID: 0,
    employeeName: "",
    emailID: "",
    jobTitle: "",
    department: "",
    mobile: "",
    adStatus: "",
    role: 0,
    cmsStatus: ""
  }
  const [searchData, setSearchData] = useState(defaultSearch)
  const [department, setDepartment] = useState(null)
  const [jobTitle, setJobtittle] = useState(null)
  const [Rolename, setRolename] = useState(null);
  const [AdStatus, setADStatus] = useState([
    { value: '1', label: 'Active' },
    { value: '0', label: 'Inactive' },
  ]);
  const [userModelShow, setUserModelShow] = useState(false)
  const [searchMode, setSearchMode] = useState(false)
  const [selectedRole, setSetlectedRole] = useState(null);
  const [openDropDown, setOpenDropDown] = useState(false)  
  const [resetPagination, setResetPagination] = useState(false)
  const navigate = useNavigate()
  const roleSelect = (e) => {
    setSearchData({ ...searchData, role: e && e.value ? e.value : "" });
    setSetlectedRole(e && e.label? e.label : "")
  }
  useEffect(() => {
    // if(roleDataCookie?.roleName !== "Admin" && roleDataCookie?.emailID===userData.emailID){
    //   notAUthorizedNavigation()
    // }
    getRolesdata()
  }, [])

  const notAUthorizedNavigation = () => {
    if(roleDataCookie?.roleName !== "Admin"&&roleDataCookie?.emailID===userData.emailID){
        toast.error("You are not authorized to view this page.")
        navigate({
          pathname: '/dashboard/claim-intimation',
          // search: "user=chandana.k@kshema.co",
        });      
    }
  }

  const handleReset = () => {
    setSearchData(defaultSearch);
    // Clear individual input values
    setSearchData({
      employeeID: 0,
      employeeName: "",
      emailID: "",
      jobTitle: "",
      department: "",
      mobile: "",
      adStatus: "",
      role: 0,
      cmsStatus: ""
    });
    getUsersdata();
  };
  const getUsersdata = (lists) => {
    cancelPreviousRequests();
    
    setLoading(true)
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/users`,{signal: controllerRef.current.signal}).then(data => {
          addRoleNameForEachUser(data.data, lists)
        }).catch(error => {
          console.log(error)
        })
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/department`).then(data => {
            const options = data?.data
               ?.filter(department => department !== null)
                ?.map(department => ({
                        value: department,
                        label: department
                     }));
                 setDepartment(options);
          //setRolename(options)
        }).catch(error => {
          console.log(error)
        })
      
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/jobTitle`).then(data => {
          const options = data?.data?.map(job => ({
            value: job,
            label: job
          }))
          setJobtittle(options);
          //setRolename(options)
        }).catch(error => {
          console.log(error)
        })
      }
        

  const addRoleNameForEachUser = (lists, newLists) => { 
    if(lists==""){
      setUsersList([])
    }
    else{
    const rolesListUpadated = newLists ? newLists : rolesList
    const updatedLists = lists.map(list => {
      return {
        ...list,
        roleName : rolesListUpadated.filter(role => role.roleID == list.userRoleMapping.roleID)[0]?.roleName
      }
    })
    setUsersList([...updatedLists])
    setLoading(false)
  }
  }
  const validateRoleForAllUsers = (users) => {
    const list = users.filter(user => (user.employeeID == roleDataCookie?.employeeID))
    if(list && list.length > 0){
      const userRoleList = rolesList.filter(role => role.roleID == list[0].userRoleMapping.roleID)
      if(userRoleList && userRoleList.length > 0 && userRoleList[0].roleName !== "Admin"){
        notAUthorizedNavigation()
      }
    }
  }
  const controllerRef = useRef(null);
  
  const cancelPreviousRequests = () => {
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    controllerRef.current = new AbortController();
  };
  const getSearchUsersdata = () => {
    cancelPreviousRequests();
    if(searchData.employeeID == 0 &&
      searchData.employeeName== "" &&
      searchData.emailID== "" &&
      searchData.jobTitle=== "" &&
      searchData.department== "" &&
      searchData.mobile== "" &&
      searchData.adStatus== "" &&
      searchData.role== 0 &&
      searchData.cmsStatus== ""){
        toast.error("Please Input a search Parameter");
              return;
            }
    setLoading(true)
    axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/searchEmployee`, { params: searchData, signal: controllerRef.current.signal }).then(data => {
      setResetPagination(!resetPagination)
      addRoleNameForEachUser(data.data)
      setSearchMode(true)
    }).catch(error => {
      console.log(error)
    }).finally(() => {
      setLoading(false)
    })
  }
  const getRolesdata = () => {
    axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/roles`).then(data => {
      setRolesList(data.data)
      const options = data?.data?.map(role => ({
        value: role.roleID,
        label: role.roleName
      }))
      setRolename(options)
      getUsersdata(data.data)
    }).catch(error => {
      console.log(error)
    })
  }

  const updateUser = () => {
    axiosRequest().put(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/user/${String(userData.userID)}`, userData)
      .then(data => {
        getUsersdata();
        if(userData.employeeID == roleDataCookie?.employeeID){ 
        let roleDataEncripted = encryptValue(JSON.stringify({...roleDataCookie, 'userRoleMapping': {...roleDataCookie, 'roleID': data.data.userRoleMapping.roleID}}))  
        saveInLocalStorage("roleData", roleDataEncripted)       
        }
        props.getLoginUserDetails(data.data.userRoleMapping.roleID, userData, false)
        toast.success("User Updated Successfully.")
      }).catch(error => {
        console.log(error);
        toast.error("Something Went Wrong.")
      })
  }

  const getPathName = () => {
    return location.pathname.split("/")[location.pathname.split("/").length - 1]
  }

  window.addEventListener('popstate', function (event) {
    if (event.state && userData !== null && userData !== undefined && userModelShow) {
      window.location.reload()
    }
  });
  const sortingData = (data) => {
    switch (data) {
      case "sortedEmail":
        if (!sortedEmail) {
          const lists = [...usersList]
          lists.sort((a, b) => a.emailID?.toLowerCase().localeCompare(b.emailID?.toLowerCase()))
          setUsersList([...lists])
          setSortedEmail(true)
        } else {
          const lists = [...usersList]
          lists.sort((a, b) => b.emailID?.toLowerCase().localeCompare(a.emailID?.toLowerCase()))
          setUsersList([...lists])
          setSortedEmail(false)
        }
        break;
      case "sortedJob":
        if (!sortedJob) {
          const lists = [...usersList]
          const jobs = lists.map(item => item?.jobTitle);
          const isSame = jobs.every(job => job === jobs[0])
          const value = isSame ? 1 : 0;
          if (value === 1) {
            setUsersList([...lists].reverse())
          } else if (value === 0) {
            lists.sort((a, b) => a?.jobTitle?.toLowerCase().localeCompare(b?.jobTitle?.toLowerCase()))
            setUsersList([...lists])
          }
          setSortedJob(true)
        } else {
          const lists = [...usersList]
          const jobs=lists.map(item=>item.jobTitle);
          const isSame=jobs.every(job=>job===jobs[0])
          const value=isSame?1:0;
          if(value===1){
            setUsersList([...lists].reverse())
          }else if(value===0)
          {
            lists.sort((a, b) => b.jobTitle?.toLowerCase().localeCompare(a.jobTitle?.toLowerCase()))
            setUsersList([...lists])
          }
          setSortedJob(false)
        }
        break;
      case "sortedDepartment":
        if (!sortedDepartment) {
          const lists = [...usersList]
          const departments = lists.map(item => item.department);
          const isSame = departments.every(department => department === departments[0])
          const value = isSame ? 1 : 0;
          if (value === 1) {
            setUsersList([...lists].reverse())
          }
          else if (value === 0) {
            lists.sort((a, b) => a.department?.toLowerCase().localeCompare(b.department?.toLowerCase()))
            setUsersList([...lists])
          }
          setSortedDepartment(true)
        } else {
          const lists = [...usersList]
          const departments=lists.map(item=>item.department);
          const isSame=departments.every(department=>department===departments[0])
          const value=isSame?1:0;
          if(value===1){
            setUsersList([...lists].reverse())
          }
          else if(value===0){
            lists.sort((a, b) => b.department?.toLowerCase().localeCompare(a.department?.toLowerCase()))
            setUsersList([...lists])
          }
          setSortedDepartment(false)
        }
        break;
      case "sortedMobile":
        if (!sortedMobile) {
          const lists = [...usersList]
          lists.sort((a, b) => a.mobile?.toLowerCase().localeCompare(b.mobile?.toLowerCase()))
          setUsersList([...lists])
          setSortedMobile(true)
        } else {
          const lists = [...usersList]
          lists.sort((a, b) => b.mobile?.toLowerCase().localeCompare(a.mobile?.toLowerCase()))
          setUsersList([...lists])
          setSortedMobile(false)
        }
        break;
      case "sortedRole":
        if (!sortedRole) {
          const sortedRolesList = [...rolesList].sort((a, b) => a.roleName.localeCompare(b.roleName));
          const Roles = sortedRolesList.map(item => item.roleName);
          const isSame = Roles.every(role => role === Roles[0])
          const value = isSame ? 1 : 0;
          if (value == 1) {
            setUsersList([...sortedRolesList].reverse())
          }
          else if (value == 0) {

            // Step 2: Map the currentItems array and retrieve the role name using the roleID
            const mappedItems = usersList.map((user) => {
              const role = sortedRolesList.find((role) => role.roleID === user?.userRoleMapping?.roleID);
              const roleName = role ? role.roleName : "";

              return { ...user, roleName };
            });

            // Step 3: Sort the mappedItems array based on the roleName attribute
            const sortedItems = [...mappedItems].sort((a, b) => a.roleName.localeCompare(b.roleName));
            setUsersList([...sortedItems])
          }
          setSortedRole(true);
        } else {
          setSortedRole(false);
          setUsersList([...usersList].reverse())
        }
        break;
      case "sortedADStatus":
        const listad = [...usersList];
        if (!sortedADStatus) {
          const Adstatuss = listad.map(item => item.adStatus);
          const isSame = Adstatuss.every(department => department === Adstatuss[0])
          const value = isSame ? 1 : 0;
          if (value == 1) {
            setUsersList([...listad].reverse())
          }
          else if (value == 0) {
            listad.sort((a, b) => b.adStatus - a.adStatus)
            setUsersList([...listad])
            setSortedADStatus(true)
          }
        } else {
          setUsersList([...listad].reverse())
          setSortedADStatus(false)
        }
        break;
      case "sortedCMSStatus":
        const listcms = [...usersList];
        if (!sortedCMSStatus) {
          const cmsStatuss = listcms.map(item => item.userRoleMapping?.cmsStatus);
          const isSame = cmsStatuss.every(cmsStatus => cmsStatus === cmsStatuss[0])
          const value = isSame ? 1 : 0;
          if (value == 1) {
            setUsersList([...listcms].reverse())
          }
          else if (value == 0) {
            listcms.sort((a, b) => b.userRoleMapping?.cmsStatus - a.userRoleMapping?.cmsStatus)
            setUsersList([...listcms])
            setSortedADStatus(true)
          }
          setSortedCMSStatus(true)
        } else {
          setUsersList([...listcms].reverse())
          setSortedCMSStatus(false)
        }
        break;

      default:
      //text = "Looking forward to the Weekend";
    }

  }
  return (
    <div>
      <header>
        <h2 className="ms-4 d-flex text-dark heading-management">User Management</h2>
      </header>
      <hr />
      {userData !== null && userData !== undefined ? (<div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" style={{ maxWidth: "740px" }}>
          <div className="modal-content p-3 " style={{height:"auto"}}>
            <div className="modal-header border-0">
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body text-center border-0">
              <img src="/kshemaImages/blank-profile-picture-973460_1280.png" className="img-cover" width="120px" height="120px" />
              <div className="row text-start mt-4">
                <div className="col-md-4">
                  <small className="text-secondary">Employee ID</small>
                  <h5>{userData.employeeID}</h5>
                </div>
                <div className="col-md-4">
                  <small className="text-secondary">Employee Name</small>
                  <h5>{userData.employeeName}</h5>
                </div>
                <div className="col-md-4">
                  <small className="text-secondary">Email ID</small>
                  <h5>{<TextTruncate text={userData.emailID} length={20} />}</h5>
                </div>
              </div>
              <div className="row text-start mt-3">
                <div className="col-md-4">
                  <small className="text-secondary">Job Title</small>
                  <h5>{userData.jobTitle}</h5>
                </div>
                <div className="col-md-4">
                  <small className="text-secondary">Department</small>
                  <h5>{userData.department}</h5>
                </div>
                <div className="col-md-4">
                  <small className="text-secondary">Mobile</small>
                  <h5>{userData.mobile}</h5>
                </div>
              </div>
              <div className="row text-start mt-3">
                <div className="col-md-4">
                  <small className="text-secondary">AD Status</small>
                  <h5>{userData.adStatus === "1" ? "Active" : "Inactive"}</h5>
                </div>
                <div className="col-md-4">
                  <small className="text-secondary">Company</small>
                  <h5>Kshema</h5>
                </div>
                <div className="col-md-4">
                  <small className="text-secondary">Role</small>
                  <Select options={Rolename} classNamePrefix="bg-gray"
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      cursor: 'pointer',
                    }),
                    option: (provided) => ({
                      ...provided,
                      cursor: 'pointer',
                    }),
                  }}
                    value={{label: userData.roleName}}
                    onChange={(e) => {
                      //if(userData.userRoleMapping!==null){
                      setUserData({ ...userData,roleName: e.label, userRoleMapping: { ...userData.userRoleMapping, roleID: e.value } })
                    }
                      //})
                    }
                  >
                  </Select>
                </div>
              </div>
              <div className="row text-start">
                <div className="col-md-4">
                  <small className="text-secondary">CMS Status</small>
                  <Select options={AdStatus} classNamePrefix="bg-gray"
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      cursor: 'pointer',
                    }),
                    option: (provided) => ({
                      ...provided,
                      cursor: 'pointer',
                    }),
                  }}
                    placeholder={userData?.userRoleMapping?.cmsStatus === "1" ? 'Active' : 'Inactive'}
                    value={userData?.userRoleMapping?.cmsStatus ? { label: userData.userRoleMapping.cmsStatus === "1" ? 'Active' : 'Inactive', value: userData.userRoleMapping.cmsStatus } : null}
                    onChange={(e) => {
                      //if(userData.userRoleMapping!==null){
                      setUserData(prevstate => ({ ...prevstate, userRoleMapping: { ...prevstate.userRoleMapping, cmsStatus: e.label == "Active" ? "1" : "0" } }))
                    }

                      //}
                    }
                  />
                </div>
              </div>
            </div>
            {editModeOn(functionalities.USER_MANAGEMENT_TAB) && (
              <div className="modal-footer d-md-flex align-items-center justify-content-center border-0">
                <div className="form-group">
                  <div className="btn btn-outline-success mt-4 mb-0 px-4" data-bs-dismiss="modal" aria-label="Close" onClick={() =>{ setOpenDropDown(false)}}>Cancel</div>
                </div>
                <div className="form-group">
                  <div className="btn btn-success m-4 mb-0 px-4" data-bs-dismiss="modal" aria-label="Close" onClick={() =>{ updateUser();setOpenDropDown(false)}} >Submit</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>) : null}
      {getPathName() == 'user-management' ?
        <section className="p-4">
          <h5>Employee Data</h5>
          <div className="border rounded p-4 px-1">
            <div className="d-md-flex align-items-center justify-content-around">
              <div className="form-group w-20">
                <label for="exampleInputPassword1">Emp ID</label>
                <input type="text" className="form-control bg-gray mt-2" id="exampleInputPassword1" placeholder="Ex:123456" onChange={(e) => {
                  const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                  e.target.value = numericValue;
                  setSearchData({ ...searchData, employeeID: e.target.value ? e.target.value : 0 })
                }}
                  value={searchData.employeeID === 0 ? '' : searchData.employeeID} />
              </div>
              <div className="form-group w-20">
                <label for="exampleInputPassword2">Emp Name</label>
                <input type="text" className="form-control bg-gray mt-2" id="exampleInputPassword2" placeholder="Ex:John Doe"
                  onChange={(e) => {
                    setSearchData({ ...searchData, employeeName: e.target.value })
                  }}
                  value={searchData.employeeName === 0 ? '' : searchData.employeeName} />
              </div>
              <div className="form-group w-20">
                <label for="exampleInputPassword3">Email ID</label>
                <input type="text" className="form-control bg-gray mt-2" id="exampleInputPassword3" placeholder="Ex:johndoe@gmail.com"
                  onChange={(e) => {
                    setSearchData({ ...searchData, emailID: e.target.value })
                  }}
                  value={searchData.emailID === 0 ? '' : searchData.emailID} />
              </div>
              <div className="form-group w-20">
                <label for="exampleInputPassword4">Mobile Number</label>
                <input type="text" className="form-control bg-gray mt-2" id="exampleInputPassword4" placeholder="Ex:852852130"
                maxLength={10}
                  onChange={(e) => {
                    if(/[^A-Za-z\d]/.test(e.target.value)){
                      return
                     }
                    const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                    e.target.value = numericValue;
                    setSearchData({ ...searchData, mobile: e.target.value })
                  }}
                  value={searchData.mobile === 0 ? '' : searchData.mobile} />
              </div>
              <div className="form-group w-20">
                <label for="exampleInputPassword5">Role</label>
                <Select id="exampleInputPassword5" options={Rolename}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    cursor: 'pointer',
                  }),
                  option: (provided) => ({
                    ...provided,
                    cursor: 'pointer',
                  }),
                }}
                  classNamePrefix="bg-gray" placeholder="Ex:Role"
                  value={searchData.role ? { label: selectedRole, value: selectedRole } : null}
                  onChange={(e) => {
                    roleSelect(e)
                  }}
                  isClearable = {true}
                />
              </div>
            </div>
            <div className="d-md-flex align-items-center justify-content-around mt-3">
              <div className="form-group w-23">
                <label for="exampleInputPassword6">Job Title</label>
                <Select id="exampleInputPassword6" options={jobTitle}
                  classNamePrefix="bg-gray"
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      cursor: 'pointer',
                    }),
                    option: (provided) => ({
                      ...provided,
                      cursor: 'pointer',
                    }),
                  }}
                  placeholder="Ex:Claims Admin"
                  value={searchData.jobTitle ? { label: searchData.jobTitle, value: searchData.jobTitle } : null}
                  onChange={(data) => {
                    setSearchData({ ...searchData, jobTitle: data?.label ? data?.label : "" })
                  }}
                  isClearable = {true}
                />
              </div>
              <div className="form-group w-23">
                <label for="exampleInputPassword7">Department</label>
                <Select
                styles={{
                  control: (provided) => ({
                    ...provided,
                    cursor: 'pointer',
                  }),
                  option: (provided) => ({
                    ...provided,
                    cursor: 'pointer',
                  }),
                }} id="exampleInputPassword7" options={department} classNamePrefix="bg-gray" placeholder="Ex:Claims"
                  value={searchData.department ? { label: searchData.department, value: searchData.department } : null}
                  onChange={(data) => {
                    setSearchData({ ...searchData, department: data?.label ? data?.label : "" })
                  }}
                  isClearable = {true}
                />
              </div>
              <div className="form-group w-23">
                <label for="exampleInputPassword8">AD Status</label>
                <Select
                styles={{
                  control: (provided) => ({
                    ...provided,
                    cursor: 'pointer',
                  }),
                  option: (provided) => ({
                    ...provided,
                    cursor: 'pointer',
                  }),
                }}
                  id="exampleInputPassword8"
                  options={AdStatus}
                  classNamePrefix="bg-gray"
                  placeholder="Ex:Active"
                  value={searchData.adStatus ? { label: searchData.adStatus === "1" ? 'Active' : 'Inactive', value: searchData.adStatus } : null}
                  onChange={(data) => {
                    setSearchData({ ...searchData,  adStatus: data?.value ? data?.value : "" })
                  }}
                  isClearable = {true}
                />
              </div>
              <div className="form-group w-23">
                <label for="exampleInputPassword9">CMS Status</label>
                <Select
                styles={{
                  control: (provided) => ({
                    ...provided,
                    cursor: 'pointer',
                  }),
                  option: (provided) => ({
                    ...provided,
                    cursor: 'pointer',
                  }),
                }}
                  id="exampleInputPassword8"
                  options={AdStatus}
                  classNamePrefix="bg-gray"
                  placeholder="Ex:Active"
                  value={searchData.cmsStatus ? { label: searchData.cmsStatus === "1" ? 'Active' : 'Inactive', value: searchData.cmsStatus } : null}
                  onChange={(data) => {
                    setSearchData({ ...searchData,  cmsStatus: data?.value ? (data?.value) : "" })
                  }}
                  isClearable = {true}
                />
              </div>
            </div>
            <div className="d-flex">
              <div className="form-group">
                <div className="btn btn-success m-4 ms-3 mb-0 px-4" onClick={() => getSearchUsersdata()}>Search</div>
              </div>
              <div className="form-group">
                <div className="btn btn-outline-success mt-4 mb-0 px-4" onClick={() => handleReset()} >Reset</div>
              </div>
            </div>
          </div>
        </section> : null}
      <hr />
      {getPathName() == 'user-management' ? <section className="p-4 table-responsive">
        {loading ? (<LoadingPage></LoadingPage>) : (
          <>
            {(<div className="d-flex justify-content-between">
              <h5>{(searchMode && currentItems && currentItems.length > 0) && 'Search Results'}</h5>
            </div>)}
            {
            usersList && usersList.length > 0 ? (
               <>
                <table className="table table-strip mt-3 text-left">
                  <thead>
                    <tr>
                      <th scope="col">Emp. ID</th>
                      <th scope="col">Emp. Name</th>
                      <th scope="col">Email <a className="pointer text-body"><svg xmlns="http://www.w3.org/2000/svg" className="pointer bi bi-filter" onClick={() => sortingData("sortedEmail")} width="16" height="16" fill="currentColor"  viewBox="0 0 16 16">
                        <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                      </svg></a></th>
                      <th scope="col">Job Title <a className="pointer text-body"><svg xmlns="http://www.w3.org/2000/svg" className="pointer bi bi-filter" onClick={() => sortingData("sortedJob")} width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                      </svg></a></th>
                      <th scope="col">Department <a className="pointer text-body"><svg xmlns="http://www.w3.org/2000/svg" className="pointer bi bi-filter" onClick={() => sortingData("sortedDepartment")} width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                      </svg></a></th>
                      <th scope="col">Mobile <a className="pointer text-body"><svg xmlns="http://www.w3.org/2000/svg" className="pointer bi bi-filter" onClick={() => sortingData("sortedMobile")} width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                      </svg></a></th>
                      <th scope="col">AD Status <a className="pointer text-body"><svg xmlns="http://www.w3.org/2000/svg" className="pointer bi bi-filter" onClick={() => sortingData("sortedADStatus")} width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                      </svg></a></th>
                      <th scope="col">Role <a className="pointer text-body"><svg xmlns="http://www.w3.org/2000/svg" className="pointer bi bi-filter" onClick={() => sortingData("sortedRole")} width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                      </svg></a></th>
                      <th scope="col">CMS Status <a className="pointer text-body"><svg xmlns="http://www.w3.org/2000/svg" className="pointer bi bi-filter" onClick={() => sortingData("sortedCMSStatus")} width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                      </svg></a></th> 
                    </tr>
                  </thead>
                  <tbody>
                    {
                      currentItems && currentItems.length > 0 ? currentItems.map(user => (
                        <tr id="a" >
                          <td id="a"><a data-bs-toggle="modal" key={user.employeeID} onClick={() => { setUserData(user); setUserModelShow(true);setOpenDropDown(false) }} data-bs-target="#exampleModal" className="text-success pointer">{user.employeeID}</a></td>
                          <td>{user.employeeName ? <TextTruncate text={user.employeeName} length={14} /> : "--"}</td>
                          <td id="a"><a data-bs-toggle="modal" key={user.emailID} onClick={() => { setUserData(user); setUserModelShow(true);setOpenDropDown(false) }} data-bs-target="#exampleModal" className="text-success pointer">{<TextTruncate text={user.emailID} length={14} />}</a></td>
                          <td>{user.jobTitle ? <TextTruncate text={user.jobTitle} length={15} /> : "--"}</td>
                          <td>{user.department ? <TextTruncate text={user.department} length={15} /> : "--"}</td>
                          <td>{user.mobile ? <TextTruncate text={user.mobile} length={15} /> : "--"}</td>
                          <td className="text-success">{user.adStatus ? <TextTruncate text={(user.adStatus === "1") ? "Active" : "Inactive"} length={10} /> : "--"}</td>
                          <td>{user.roleName}</td>
                          {/* <td><TextTruncate text={rolesList.map((role) => { if (role.roleID === user?.userRoleMapping?.roleID) { return <span key={role.roleID}><TextTruncate text={role.roleName} length={15}/></span> }  })} length={10} /></td> */}
                          <td className="text-success"><TextTruncate text={(user?.userRoleMapping?.cmsStatus === "1") ? "Active" : "Inactive"} length={10} /> </td>
                        </tr>
                      )) : <tr>
                        <td align="center" colspan="6">No Data Found</td>
                      </tr>}
                  </tbody>
                </table>
                <ListsPagination setCurrentItems={setCurrentItems} lists={usersList} resetPagination={resetPagination}/> 
               </>

              ) : <div className="text-center">
              <div style={{ paddingTop: "100px" }}><NoDataFound text="No Data Found"/></div>
          </div>
            }    
          </>
        )}
      </section> : null}
    </div>
  )
};

export default UserManagment;